var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "split-container" }, [
    _c("div", { staticClass: "form-container" }, [
      _c(
        "div",
        {
          staticClass:
            "columns is-centered is-vcentered is-multiline is-mobile",
        },
        [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "field" }, [
              _c("p", { staticClass: "control has-icons-left" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.promo_code,
                      expression: "promo_code",
                    },
                  ],
                  ref: "inputCode",
                  staticClass: "input",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("placeholder.promo_code"),
                    maxlength: "16",
                  },
                  domProps: { value: _vm.promo_code },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.submitPromoCode.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.promo_code = $event.target.value
                    },
                  },
                }),
                _c(
                  "span",
                  { staticClass: "icon is-small is-left" },
                  [_c("gift-icon", { attrs: { size: "1.5x" } })],
                  1
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "column is-narrow" }, [
            _c("div", { staticClass: "field" }, [
              _c("p", { staticClass: "control has-text-centered" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.submitPromoCode },
                  },
                  [_vm._v(_vm._s(_vm.$t("button.submit")))]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm.missingCode
        ? _c(
            "article",
            { staticClass: "message is-danger", attrs: { transition: "fade" } },
            [
              _c("div", { staticClass: "message-body" }, [
                _vm._v(_vm._s(_vm.$t("alert.missing_promo_code"))),
              ]),
            ]
          )
        : _vm._e(),
      _vm.invalidCode
        ? _c(
            "article",
            { staticClass: "message is-danger", attrs: { transition: "fade" } },
            [
              _c("div", { staticClass: "message-body" }, [
                _vm._v(_vm._s(_vm.$t("alert.invalid_promo_code"))),
              ]),
            ]
          )
        : _vm.expiredCode
        ? _c(
            "article",
            { staticClass: "message is-danger", attrs: { transition: "fade" } },
            [
              _c("div", { staticClass: "message-body" }, [
                _vm._v(_vm._s(_vm.$t("alert.expired_promo_code"))),
              ]),
            ]
          )
        : _vm.errorPage
        ? _c(
            "article",
            { staticClass: "message is-danger", attrs: { transition: "fade" } },
            [
              _c("div", { staticClass: "message-body" }, [
                _vm._v(_vm._s(_vm.$t("alert.generic_error"))),
              ]),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }